import { FC } from 'react';

import { logo_mindd, logo_mindd_dark, logo_mindd_primary } from '.';
const LogoIcon: FC<{ width?: number; type?: 'white' | 'dark' | 'primary' }> = ({ width = 24, type = 'white' }) => {
  if (type === 'primary') {
    return <img src={logo_mindd_primary} width={width} alt="MINDD LOGO" />;
  }
  if (type === 'dark') {
    return <img src={logo_mindd_dark} width={width} alt="MINDD LOGO" />;
  }
  return <img src={logo_mindd} width={width} alt="MINDD LOGO" />;
};

export default LogoIcon;
